import { useGetAllProvidersCached } from 'react-easyrocket';
import { ProvidersSearchResults } from './components/ProvidersSearchResults';
import { AllProviders } from './components/AllProviders';

export const SearchingProviders = () => {
  const { providers: allProviders, isFetching } = useGetAllProvidersCached();
  return (
    <div className="px-1 flex flex-col">
      <ProvidersSearchResults providers={allProviders} isFetching={isFetching} />
      <AllProviders providers={allProviders} isFetching={isFetching} />
    </div>
  );
};
